export default "__VITE_ASSET__2fc3f81e__"